import { useState } from 'react';
import { Link } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import { Dialog } from '@headlessui/react';
import { Bars3Icon, XMarkIcon } from '@heroicons/react/24/outline';

const navLinks = [
    // { name: 'Work', href: '/works' },
    // { name: 'Contact', href: '/contact' },
]

export default function Navigation() {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

    return (
        <header className="fixed inset-x-0 top-0 z-50">
            <div className="absolute inset-0 bg-void/70 backdrop-blur-xl border-b border-border-subtle" />
            <nav className="relative flex items-center justify-between px-6 py-4 mx-auto max-w-6xl lg:px-8" aria-label="Global">
                <div className="flex lg:flex-1">
                    <a href="/" className="flex items-center gap-3 group">
                        <img
                            className="h-10 w-auto"
                            src="/images/logos/Big-Web-Labs-Logo.png"
                            alt="Big Web Labs"
                        />
                    </a>
                </div>

                {/* <div className="flex lg:hidden">
                    <button
                        type="button"
                        className="p-2 text-text-secondary hover:text-accent transition-colors"
                        onClick={() => setMobileMenuOpen(true)}
                    >
                        <span className="sr-only">Open menu</span>
                        <Bars3Icon className="h-6 w-6" />
                    </button>
                </div> */}

                <div className="flex lg:items-center lg:gap-x-10">
                    {navLinks.map((item) => (
                        item.href.startsWith('/#') ? (
                            <HashLink
                                key={item.name}
                                to={item.href}
                                smooth
                                className="text-sm font-outfit font-medium text-text-secondary hover:text-text-primary transition-colors duration-300"
                            >
                                {item.name}
                            </HashLink>
                        ) : (
                            <Link
                                key={item.name}
                                to={item.href}
                                className="text-sm font-outfit font-medium text-text-secondary hover:text-text-primary transition-colors duration-300"
                            >
                                {item.name}
                            </Link>
                        )
                    ))}
                    <a
                        href="https://calendly.com/bigweblabs/big-web-labs"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-sm font-outfit font-semibold px-5 py-2.5 rounded-full bg-accent/10 text-accent border border-accent/20 hover:bg-accent/20 hover:border-accent/40 transition-all duration-300"
                    >
                        Book a Call
                    </a>
                </div>
            </nav>

            {/* <Dialog as="div" className="lg:hidden" open={mobileMenuOpen} onClose={setMobileMenuOpen}>
                <div className="fixed inset-0 z-50 bg-void/80 backdrop-blur-sm" />
                <Dialog.Panel className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-void border-l border-border-subtle px-6 py-6 sm:max-w-sm">
                    <div className="flex items-center justify-between">
                        <a href="/" className="flex items-center gap-3">
                            <img
                                className="h-10 w-auto"
                                src="/images/logos/Big-Web-Labs-Logo.png"
                                alt="Big Web Labs"
                            />
                            <span className="text-sm font-syne font-bold text-text-primary">Big Web Labs</span>
                        </a>
                        <button
                            type="button"
                            className="p-2 text-text-secondary hover:text-accent transition-colors"
                            onClick={() => setMobileMenuOpen(false)}
                        >
                            <span className="sr-only">Close menu</span>
                            <XMarkIcon className="h-6 w-6" />
                        </button>
                    </div>
                    <div className="mt-12 flow-root">
                        <div className="space-y-1">
                            {navLinks.map((item) => (
                                <Link
                                    key={item.name}
                                    to={item.href}
                                    onClick={() => setMobileMenuOpen(false)}
                                    className="block rounded-lg px-4 py-3 text-base font-outfit font-medium text-text-secondary hover:text-text-primary hover:bg-elevated transition-all duration-200"
                                >
                                    {item.name}
                                </Link>
                            ))}
                            <div className="pt-6">
                                <a
                                    href="https://calendly.com/bigweblabs/big-web-labs"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="block text-center text-sm font-outfit font-semibold px-5 py-3 rounded-full bg-accent/10 text-accent border border-accent/20 hover:bg-accent/20 transition-all duration-300"
                                >
                                    Book a Call
                                </a>
                            </div>
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog> */}
        </header>
    )
}
